// extracted by mini-css-extract-plugin
export var locationCard = "_f0-0";